import CountryISOCode from './CountryISOCode'

const FLAGS_CDN_BASE_URL = 'https://cdn.51trips.com/flags'

// countryCode is the numeric ISO 3166-1 / UN M49 code (e.g. "840"), including the
// hyphen-suffixed subregion codes used for Spanish autonomous communities and UK nations
// (e.g. "724-01"). The CDN mirrors that same code space.
export const getFlagUrl = (countryCode: string): string => `${FLAGS_CDN_BASE_URL}/${countryCode}.svg`

export const getFlagUrlFromIso2 = (iso2: string): string | undefined => {
  const isoCode = CountryISOCode.fromCode(iso2.toUpperCase())
  return isoCode ? getFlagUrl(isoCode.numeric) : undefined
}
